module.exports = __webpack_public_path__ + "static/media/Flooring.bdcf97d2.png";